import React from 'react';
import { Modal, Typography } from 'antd';

type CopyModalProps = {
  value: string;
  onClose: ()=> void;
};

const CopyModal = (props: CopyModalProps) => {
  return (
      <Modal style={{height: 100, width: 520}} visible={true} onCancel={()=>props.onClose()} footer={false}>
        <Typography.Paragraph style={{marginTop: 20}} copyable>{props.value}</Typography.Paragraph>
      </Modal>
  );
};

export default CopyModal
